import { DateFormat, TimeFormat } from 'Constants/Configuration'
import dayjs from 'dayjs'
import 'dayjs/plugin/timezone'
import 'dayjs/plugin/localeData'

export const createTimezoneCorrectedEpoch = inputDate => {
  return inputDate
    ? new Date(inputDate).getTime() + new Date(inputDate).getTimezoneOffset() * -60000
    : new Date().getTime() + new Date().getTimezoneOffset() * -60000
}

export const createTimezoneCorrectedDate = inputDate => {
  return new Date(createTimezoneCorrectedEpoch(inputDate))
}

export const createTimezoneUncorrectedEpoch = inputDate => {
  return inputDate
    ? new Date(inputDate).getTime() + new Date(inputDate).getTimezoneOffset() * 60000
    : new Date().getTime() + new Date().getTimezoneOffset() * 60000
}

export const createTimezoneUncorrectedDate = inputDate => {
  return new Date(createTimezoneUncorrectedEpoch(inputDate))
}

export const createMidnightDateTimezoneCorrected = inputDate => {
  return createTimezoneCorrectedDate(new Date(inputDate).setHours(0, 0, 0))
}

export const createBeforeMidnightDateTimezoneCorrected = inputDate => {
  return createTimezoneCorrectedDate(new Date(inputDate).setHours(23, 59, 0))
}

export const getHoursBeforeCurrentHour = current => {
  const hours = []

  if (current && current.isSame(dayjs(), 'day')) {
    const currentHour = dayjs().hour()
    for (let i = 0; i < currentHour; i++) {
      hours.push(i)
    }
  }

  return hours
}

export const getMinutesBeforeCurrentMinutesForCurrentHour = (selectedHour, current) => {
  const minutes = []

  if (current && current.isSame(dayjs(), 'day') && selectedHour <= dayjs().hour()) {
    const currentMinute = dayjs().minute()
    for (let i = 0; i <= currentMinute; i++) {
      minutes.push(i)
    }
  }

  return minutes
}

export const isDateAfterToday = current => {
  return current && current > dayjs().endOf('day')
}

export const isDateBefore = (startDate, endDate) => {
  return dayjs(startDate) < dayjs(endDate)
}

export const isSameDateTime = (startDate, endDate) => {
  return dayjs(startDate).isSame(dayjs(endDate))
}
export const isSameDate = (startDate, endDate) => {
  return dayjs(startDate).isSame(dayjs(endDate), 'day')
}

export const convertDateToRomeTimeZone = utcDateTime => {
  return dayjs.tz(utcDateTime, 'Europe/Rome')
}
export const addDays = (date, days) => {
  var result = new Date(date)
  result.setDate(result.getDate() + days)
  return result
}

export function getDayDiff(startDate: Date, endDate: Date): number {
  const msInDay = 24 * 60 * 60 * 1000

  return Math.round(Math.abs(endDate.getTime() - startDate.getTime()) / msInDay)
}

export const localeSpecificDate = (inputDate: string, time: boolean = true) => {
  return dayjs(inputDate, DateFormat + (time ? ` ${TimeFormat}` : ''))
}
export const isValidDate = inputDate => {
  return !isNaN(Date.parse(inputDate))
}

/**
 * Get a current culture array of months
 * @returns
 */
export const getArrayOfMonths = () => dayjs.months()
